module.exports = __webpack_public_path__ + "static/media/ls-desktop-and-web-iconography.0ca18f66.woff";